import { fallBackToOriginalImage } from '~/utils/images/responsiveImage'

// A resized copy from /_img that fails to load (a cold instance timing out,
// a 5xx) falls back to the original upload instead of a broken image. The
// listener runs in the capture phase on window, before the image's own
// @error handlers, and stops the event there: a component only hears about a
// failure of the original itself, so a logo or photo is never hidden for a
// resize problem. Images that failed before this ran (server-rendered, before
// hydration) are swept once.
export default defineNuxtPlugin(() => {
  window.addEventListener('error', (event) => {
    if (fallBackToOriginalImage(event.target)) event.stopImmediatePropagation()
  }, true)
  for (const img of Array.from(document.querySelectorAll('img'))) {
    if (img.complete && img.naturalWidth === 0) fallBackToOriginalImage(img)
  }
})
